export enum UserType{
    ADMIN = 2,
    USER = 0,
    INSTITUTE = 1
}